import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";

import Navbar from "./components/js/Header";
import Home from "./components/js/Home";
import LandingPage from "./components/js/LandingPage";

import About from "./components/js/About";
import Login from "./components/js/Login";
import BlastComponent from "./components/js/BlastComponent";
import TaxonomyComponent from "./components/js/TaxonomyComponent";
import NucleotideComponent from "./components/js/NucleotideComponent";
import GeneComponent from "./components/js/GeneComponent";
import PubmedComponent from "./components/js/PubmedComponent";
import GenomeAssemblyComponent from "./components/js/GenomeAssemblyComponent";

import LeftSidebar from "./components/js/LeftSidebar";
import RightSidebar from "./components/js/RightSidebar";
import Footer from "./components/js/Footer";

import ContactForm from "./components/js/ContactForm";
import ProteinComponent from "./components/js/ProteinComponent";
import UniProtComponent from "./components/js/UniProtComponent";
import GeoDatasetComponent from "./components/js/GeoDatasetComponent";
import LinksComponent from "./components/js/LinksComponent";
import PrimerComponent from "./components/js/PrimerComponent";
import BookshelfComponent from "./components/js/BookshelfComponent";
import PMCArticleComponent from "./components/js/PMCArticleComponent";
import PathwayComponent from "./components/js/PathwayComponent";
import SRAComponent from "./components/js/SRAComponent";
import SubstanceComponent from "./components/js/SubstanceComponent";
import BioassayComponent from "./components/js/BioassayComponent";
import BioprojectComponent from "./components/js/BioprojectComponent";
import BiosampleComponent from "./components/js/BiosampleComponent";
import ProteinGroupComponent from "./components/js/ProteinGroupComponent";

import ToolComponent from "./components/js/ToolComponent";
import UploadComponent from "./components/js/UploadComponent";
import UploadVersionComponent from "./components/js/UploadVersionComponent";
import DatasetSubmissionForm from "./components/js/DatasetSubmissionForm";

import Register from "./components/js/Register";

import Team from "./components/js/Team";
import Contact from "./components/js/Contact";
import NotFound from "./components/js/NotFound";
import ClustalOmega from "./components/js/ClustalOmega";

import ForgotPasswordRequest from "./components/js/ForgotPasswordRequest";
import ResetPasswordConfirm from "./components/js/ResetPasswordConfirm";

import Help from "./components/js/Help";
import FAQs from "./components/js/FAQs";

import "./App.css";

const App = () => {
  const location = useLocation();

  // Only /home gets sidebar layout
  const isHomePage = location.pathname === "/home";

  return (
    <div
      className={`app-container ${
        isHomePage ? "home-page" : "full-page-layout"
      }`}
    >
      <Navbar />

      {/* Landing Page */}
      {location.pathname === "/" ? (
        <div className="full-page">
          <Routes>
            <Route path="/" element={<LandingPage />} />
          </Routes>
        </div>
      ) : isHomePage ? (
        /* Database Home Page */
        <div className="home-layout">
          <LeftSidebar />

          <div className="main-content">
            <Routes>
              <Route path="/home" element={<Home />} />
            </Routes>
          </div>

          <RightSidebar />
        </div>
      ) : (
        /* All Other Pages */
        <div className="full-page">
          <Routes>
            <Route path="/about" element={<About />} />
            <Route path="/login" element={<Login />} />

            <Route path="/taxonomy" element={<TaxonomyComponent />} />
            <Route path="/pubmed" element={<PubmedComponent />} />
            <Route path="/nucleotide" element={<NucleotideComponent />} />
            <Route path="/gene" element={<GeneComponent />} />
            <Route
              path="/genomeassembly"
              element={<GenomeAssemblyComponent />}
            />
            <Route path="/blast" element={<BlastComponent />} />
            <Route path="/contact" element={<ContactForm />} />
            <Route path="/protein" element={<ProteinComponent />} />
            <Route path="/proteins" element={<UniProtComponent />} />
            <Route path="/links" element={<LinksComponent />} />
            <Route path="/book" element={<BookshelfComponent />} />
            <Route path="/primer3" element={<PrimerComponent />} />
            <Route path="/pmc" element={<PMCArticleComponent />} />
            <Route path="/pathway" element={<PathwayComponent />} />
            <Route path="/sra" element={<SRAComponent />} />
            <Route path="/substance" element={<SubstanceComponent />} />
            <Route path="/bioassay" element={<BioassayComponent />} />
            <Route path="/bioproject" element={<BioprojectComponent />} />
            <Route path="/biosample" element={<BiosampleComponent />} />
            <Route
              path="/proteinuniprot"
              element={<ProteinGroupComponent />}
            />

            <Route path="/faqs" element={<FAQs />} />
            <Route path="/help" element={<Help />} />

            <Route path="/tools" element={<ToolComponent />} />
            <Route path="/uploads" element={<UploadComponent />} />
            <Route
              path="/upload-versions"
              element={<UploadVersionComponent />}
            />

            <Route path="/register" element={<Register />} />
            <Route path="/team" element={<Team />} />
            <Route path="/contact_form" element={<Contact />} />
            <Route path="/clustalomega" element={<ClustalOmega />} />

            {/* Dynamic Routes */}

            <Route
              path="/biosample/:accession"
              element={<BiosampleComponent />}
            />

            <Route
              path="/bioproject/:bio_project_accession"
              element={<BioprojectComponent />}
            />

            <Route path="/gene/:gene_id" element={<GeneComponent />} />

            <Route
              path="/nucleotide/:accession"
              element={<NucleotideComponent />}
            />

            <Route
              path="/protein/:accession"
              element={<ProteinComponent />}
            />

            <Route path="/pmc/:pmcid" element={<PMCArticleComponent />} />

            <Route
              path="/sra/:expeiment_accession"
              element={<SRAComponent />}
            />

            <Route path="/pathway/:accession" element={<PathwayComponent />} />

            <Route
              path="/substance/:record_number"
              element={<SubstanceComponent />}
            />

            <Route path="/bioassay/:aid" element={<BioassayComponent />} />

            <Route
              path="/taxonomy/:tax_id"
              element={<TaxonomyComponent />}
            />

            <Route
              path="/genomeassembly/:assembly_accession"
              element={<GenomeAssemblyComponent />}
            />

            <Route path="/geodata/*" element={<GeoDatasetComponent />} />
            <Route path="/geodata" element={<GeoDatasetComponent />} />

            {/* Password Reset */}

            <Route
              path="/forgot-password"
              element={<ForgotPasswordRequest />}
            />

            <Route
              path="/reset-password-confirm/:uid/:token"
              element={<ResetPasswordConfirm />}
            />

            {/* Dataset Submission */}

            <Route
              path="/dataset-submissions"
              element={<DatasetSubmissionForm />}
            />

            {/* 404 */}

            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default App;
